export default [
  'P',
  'D',
  'M',
  'P-LPG',
  'P-EE',
  'CNG',
  'H',
  'LNG',
  'BD',
  'E85',
  'EE',
  '999',
]